'use strict';
var assetsHelper = require('../helper/assetsHelper');

/**
 * 获取外壳组件
 * @param style
 * @param style.type 风格类型
 * @param style.name 风格名称
 * @param isHorizontal 是否是横向
 * @returns {*}
 */
function getShellComponents(style, isHorizontal) {
  if (style.type === 'wireframe') {
    if (isHorizontal) {
      return {
        top:  assetsHelper.getAsset('shell'/ + style.name + '/h_top_center_wireframe.png'),
        bottom: assetsHelper.getAsset('shell/' + style.name + '/h_bottom_center_wireframe.png')
      };
    }
    return {
      top: assetsHelper.getAsset('shell/' + style.name + '/top_center_wireframe.png'),
      bottom: assetsHelper.getAsset('shell/' + style.name + '/bottom_center_wireframe.png')
    };
  }
  if (isHorizontal) {
    return {
      whole: assetsHelper.getAsset('shell/' + style.name + '/h_whole.png'),
      top: assetsHelper.getAsset('shell/' + style.name + '/h_top_center.png'),
      bottom: assetsHelper.getAsset('shell/' + style.name + '/h_bottom_center.png')
    };
  }
  return {
    whole: assetsHelper.getAsset('shell/' + style.name + '/whole.png'),
    top: assetsHelper.getAsset('shell/' + style.name + '/top_center.png'),
    bottom: assetsHelper.getAsset('shell/' + style.name + '/bottom_center.png')
  };
}

/**
 * 获取外壳组件的尺寸
 * @param styleName
 * @param isHorizontal
 * @returns {*}
 */
function getShellComponentSize(styleName, isHorizontal) {
  var config;
  switch (styleName) {
  case 'iPhone':
    config = {
      width: 854,
      height: 1771,
      screenWidth: 760,
      screenHeight: 1350,
      xR: 6,
      yR: 6
    };
    break;
  case 'iPad':
    config = {
      width: 1404,
      height: 2000,
      screenWidth: 1251,
      screenHeight: 1666,
      radius: 16,
      xR: 16,
      yR: 16
    };
    break;
  case 'Android':
    config = {
      width: 756,
      height: 1434,
      screenWidth: 685,
      screenHeight: 1230,
      xR: 6,
      yR: 8
    };
    break;
  case 'Tablet':
    config = {
      width: 1009,
      height: 1633,
      screenWidth: 892,
      screenHeight: 1298,
      xR: 16,
      yR: 16
    };
    break;
  default:
    config = {
      width: 1,
      height: 1,
      screenWidth: 1,
      screenHeight: 1,
      xR: 1,
      yR: 1
    };
  }
  if (isHorizontal) {
    return {
      width: config.height,
      height: config.width,
      screenWidth: config.screenHeight,
      screenHeight: config.screenWidth,
      xR: config.yR,
      yR: config.xR
    };
  }
  return config;
}

function getShellInfoByPlatform(platform, shell) {

  switch (platform) {
  case 'MtMobile':
      if(['iPhone', 'Android'].indexOf(shell) !== -1) {
        return shell;
      }
    return 'iPhone';
  case 'MtPad':
    if(['iPad', 'Tablet'].indexOf(shell) !== -1) {
      return shell;
    }
    return 'iPad';
  case 'MtDesktop':
    return 'desktop';
  default:
    return '';
  }
}

module.exports = {
  getShellComponents: getShellComponents,
  getShellComponentSize: getShellComponentSize,
  getShellInfoByPlatform: getShellInfoByPlatform
};



// WEBPACK FOOTER //
// ./src/helper/deviceShellHelper.js